import { API } from "@/services"

export const USER_ACTIONS_ENDPOINTS = {
  create(data={}){
    return API.Axios.error_capture.v1.request({
      url: `user-actions`,
      method: 'POST',
      data,
    })
  },
  sync(data={}){
    return API.Axios.error_capture.v1.request({
      url: `user-actions/sync`,
      method: 'POST',
      data,
    })
  },
  get(params={},extra){
    return API.Axios.error_capture.v1.request({
      ...extra,
      url: `user-actions`,
      method: 'GET',
      params,
    })
  },
  downloadExcel(params={}){
    return API.Axios.error_capture.v1.request({
      url: `user-actions/excel/download`,
      method: 'GET',
      params,
      responseType: 'blob'
    })
  },
  getActionsDoughnutChart(params={}){
    return API.Axios.error_capture.v1.request({
      url: `user-actions/chart/actions`,
      method: 'GET',
      params,
    })
  },
}